import { localHostBaseURL } from '../../helpers/domainURL';
import requestUtil from '../../helpers/requestUtil';
import { setLoading } from '../common/Loader/slice';
import {
  loginFailure,
  loginRequest,
  loginSuccess,
  reset,
  setProfileFlag,
  updateBankAccountType,
  updateLocations,
  updateMasterData,
} from './slice';

export function login({ url, email, password, iv, userClientTimeZone }) {
  return async (dispatch) => {
    dispatch(loginRequest());
    dispatch(setLoading(true));
    try {
      const response = await requestUtil(`${url}/Authenticate/e/signin`, 'POST', {
        username: email, encryptPassword: password,
        iv, userClientTimeZone, websiteDomainName: window.location.hostname === 'localhost' ? localHostBaseURL : window.location.hostname 
      });
      dispatch(loginSuccess(response));
      return response;
    } catch (error) {
      dispatch(loginFailure(error.message));
      return error;
    }
    finally {
      dispatch(setLoading(false));
    }
  };
}

export const getLocationDetails = ({ url, employerUniqueId }) => {

  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const locations = await requestUtil(`${url}/Locations/get-location-list-for-dropdown/${employerUniqueId}`, 'GET');
      sessionStorage?.setItem('locationList', JSON.stringify(locations));
      dispatch(updateLocations(locations));

      // const jobtypeobj = await requestUtil(`${url}/Dropdown/get-jobtype-asobject`, 'GET');

      // sessionStorage?.setItem('jobtypeobj', JSON.stringify(jobtypeobj));
      //console.log("JobType:",jobtypeobj.Security);
    } catch (error) {
      dispatch(loginFailure(error.message));
    } finally {
      dispatch(setLoading(false));
    }
  }
}

export function logOut() {
  return async (dispatch) => {
    dispatch(reset());
  };
}

export function resetError() {
  return async (dispatch) => {
    dispatch(reset());
  };
}

export function updateProfileFlag(flagName) {
  return async (dispatch) => {
    dispatch(setProfileFlag(flagName));
  };
}

export const getDynamicFormData = (url) => {
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await requestUtil(
        `${url}/Dropdown/get-controltypeenum-asobject`,
        'GET'
      );
      sessionStorage.setItem('inputTypes', JSON.stringify(response));
    } catch (error) { }
    dispatch(setLoading(false));
  };
};



const getIPAddress = async () => {
  const addressIP = await fetch("https://api.ipify.org/?format=json");
  const result = await addressIP.json();
  return result?.ip ? result?.ip : "string";
}
const getBrowserName = () => {
  const userAgent = navigator.userAgent;
  const userAgentData = navigator?.userAgentData;
  let browserName;
  const dataBrowserName = userAgentData?.brands?.at(-1)?.brand;
  if (userAgent.includes("Firefox")) {
    browserName = "Firefox";
  } else if (userAgent.includes("Chrome")) {
    browserName = "Google Chrome";
  } else if (userAgent.includes("Safari")) {
    browserName = "Safari";
  } else if (userAgent.includes("MSIE") || userAgent.includes("Trident/")) {
    browserName = "Internet Explorer";
  } else if (userAgent.includes("Edge")) {
    browserName = "Microsoft Edge";
  }
  return dataBrowserName ?? browserName ?? "Unknown"
}

const getOsName = () => {
  const userAgent = navigator.userAgent;
  const userAgentData = navigator?.userAgentData;
  const osName = userAgentData?.platform
  let operatingSystem;
  if (userAgent.includes("Windows")) {
    operatingSystem = "Windows";
  } else if (userAgent.includes("Mac OS")) {
    operatingSystem = "Mac OS";
  } else if (userAgent.includes("Linux")) {
    operatingSystem = "Linux";
  } else if (userAgent.includes("Android")) {
    operatingSystem = "Android";
  } else if (userAgent.includes("iOS")) {
    operatingSystem = "iOS";
  }
  return osName ?? operatingSystem ?? "Unknown"
}
const getWebAppVersion = () => {
  const userAgentData = navigator?.userAgentData;
  const isMobile = userAgentData?.mobile
  return !isMobile ? 1 : 0;
}
export const getTrackingParams = (url, params, response) => {
  return async (dispatch) => {
    try {
      const { appUserId, employerId, result } = response;
      const sourceIP = await getIPAddress();
      const browser = getBrowserName();
      const operatingSystem = getOsName();
      const newParams = {
        ...params,
        browser,
        sourceIP,
        operatingSystem,
        appUserId: appUserId ?? null,
        employerId: employerId ?? null,
        loginResult: result ?? 0,
      };
      await requestUtil(`${url}/Tracking/userloginhistory`, "POST", {
        ...newParams,
      });
    } catch (error) {
      return error;
    }
  };
};


export const fetchDepsUnits = ({ baseUrl }) => {
  return async (dispatch) => {
    try {
      const depsUnits = await requestUtil(`${baseUrl}/Departments/get-active-department-details`);
      const depsUnitsMaster = depsUnits?.departmentList?.length ? depsUnits?.departmentList?.map(item => ({ name: item?.departmentName, id: item?.candidateDepartmentId })) : [];
      dispatch(updateMasterData({ name: "depsUnitsMaster", value: depsUnitsMaster }));
      return depsUnitsMaster
    } catch (error) {
      console.log({ error });
    } finally {
      // dispatch(setLoadingFlagDecrement());
    }
  };
};

export const getAccountTypeOptions = ({baseURL}) => {
  return async(dispatch) => {
    try {
      const response = await requestUtil(`${baseURL}/Dropdown/getaccounttypes`);
      const accountTypes = response?.length ? response : [];
      dispatch(updateBankAccountType(accountTypes));
      return accountTypes;
    } catch (error) {
      return error;
    }
  }
};